import { Image } from 'react-native'
import React from 'react'
import Colors from '../Constants/Colors'

interface ImageMenuProps {
  uri: string
  mr?: number
}

const ImageMenu = ({ uri, mr }: ImageMenuProps) => {
  return (
    <Image
      style={{
        width: 28,
        height: 28,
        marginRight: mr ?? 0,
        // marginRight: 10,
        // backgroundColor: Colors.primaryColor,
      }}
      source={{
        uri: uri,
      }}
    />
  )
}

export default ImageMenu
